import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import eventHub from './scripts/eventHub';
import translate from './scripts/translate';
import { getLang, sendGAEvent } from './scripts/utils';

Vue.config.productionTip = false;
Vue.prototype.$translate = (key) => translate(key, getLang());
Vue.prototype.$eventHub = eventHub;
Vue.prototype.$sendEvent = sendGAEvent;

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
